import master from 'usecases/app_calendar/jp/gengo/master';

export interface Gengo {
  name: string;
  kana: string;
  start: number;
  end: number;
  id: number;
  age: string;
}

export const gengoList = (year?: number): Array<Gengo> => {
  const csvArray: Array<any> = [];
  if (year) {
    master.forEach((d) => {
      if (Number(d[2]) <= year && year <= Number(d[3])) {
        csvArray.push(d);
      }
    });
    csvArray.reverse();
  } else {
    master.forEach((d) => {
      csvArray.push(d);
    });
    csvArray.reverse();
  }

  return csvArray
    .filter((data) => {
      return data[4] === '令和';
    })
    .map((data) => {
      return {
        name: data[4] || null,
        kana: data[5] || null,
        start: data[2] || null,
        end: data[3] || null,
        id: data[0] || null,
        age: data[1] || null,
      };
    });
};
